import { EquipmentHierarchy, EquipmentNode, WorkOrderEvent, TrendChartData } from './types';

/**
 * Helper function to determine if mock data should be used
 * Works in both Vite (browser) and Jest (Node.js) environments
 */
export const isDevelopmentWithMockData = (): boolean => {
    // Check if we're in a Vite environment (import.meta is available)
    // if (typeof import.meta !== 'undefined' && import.meta.env) {
    //     return import.meta.env.DEV && import.meta.env.VITE_USE_MOCK_DATA === 'true';
    // }

    // Fallback for Jest/Node environment
    // return process.env.NODE_ENV === 'development' && process.env.VITE_USE_MOCK_DATA === 'true';
    // return process.env.VITE_USE_MOCK_DATA === 'true';
    return false;
};

export const equipmentList: EquipmentHierarchy[] = [
    {
        rootNode: {
            id: "AFE3.0.DIS.LN.01",
            name: "AFE3.0.DIS.LN.01",
            type: "system",
            parentId: "AFE3.0.DIS.LN",
            children: [
                {
                    id: "AFE3.0.DIS.LN.01.811015",
                    name: "AFE3.0.DIS.LN.01.811015",
                    type: "position",
                    parentId: "AFE3.0.DIS.LN.01",
                    children: [
                        {
                            id: "BNLS",
                            name: "BNLS",
                            type: "asset",
                            parentId: "AFE3.0.DIS.LN.01.811015",
                        },
                        {
                            id: "BNRS",
                            name: "BNRS",
                            type: "asset",
                            parentId: "AFE3.0.DIS.LN.01.811015",
                        },
                        {
                            id: "GEAR",
                            name: "GEAR",
                            type: "asset",
                            parentId: "AFE3.0.DIS.LN.01.811015",
                        },
                        {
                            id: "HPRS",
                            name: "HPRS",
                            type: "asset",
                            parentId: "AFE3.0.DIS.LN.01.811015",
                        },
                        {
                            id: "PTLS",
                            name: "PTLS",
                            type: "asset",
                            parentId: "AFE3.0.DIS.LN.01.811015",
                        },
                        {
                            id: "PTRS",
                            name: "PTRS",
                            type: "asset",
                            parentId: "AFE3.0.DIS.LN.01.811015",
                        },
                        {
                            id: "TPLS",
                            name: "TPLS",
                            type: "asset",
                            parentId: "AFE3.0.DIS.LN.01.811015",
                        },
                        {
                            id: "TPRS",
                            name: "TPRS",
                            type: "asset",
                            parentId: "AFE3.0.DIS.LN.01.811015",
                        },
                    ]
                }
            ]
        },
        site: "BCN1",
        apmId: "ABC.DEF",
    }
]

export const workOrdersList: WorkOrderEvent[] = [
    {
        id: "WO1",
        jobType: "PM",
        description: "Preventive Maintenance",
        createdDate: "2025-01-01",
        equipmentId: "AFE3.0.DIS.LN.01.811015",
        status: "Completed",
        priority: 1,
        reqm: "REQM1",
        failure: "Failure1",
        cause: "Cause1"
    },
    {
        id: "WO2",
        jobType: "FPM",
        description: "Change Spare part",
        createdDate: "2025-01-02",
        equipmentId: "AFE3.0.DIS.LN.01.811015",
        status: "Completed",
        priority: 1,
        reqm: "REQM2",
        failure: "Failure2",
        cause: "Cause2"
    },
    {
        id: "WO3",
        jobType: "CM",
        description: "Corrective Maintenance - Belt replacement",
        createdDate: "2025-01-15",
        equipmentId: "AFE3.0.DIS.LN.01.811015",
        status: "In Progress",
        priority: 2,
        reqm: "REQM3",
        failure: "Failure3",
        cause: "Cause3"
    },
    {
        id: "WO4",
        jobType: "BRKD",
        description: "Emergency breakdown repair",
        createdDate: "2025-01-20",
        equipmentId: "AFE3.0.DIS.LN.01.811015",
        status: "Open",
        priority: 4,
        reqm: "REQM4",
        failure: "Failure4",
        cause: "Cause4"
    },
    {
        id: "WO5",
        jobType: "SC",
        description: "Schedule change for maintenance window",
        createdDate: "2025-01-25",
        equipmentId: "AFE3.0.DIS.LN.01.811015",
        status: "Completed",
        priority: 1,
        reqm: "REQM5",
        failure: "Failure5",
        cause: "Cause5"
    },
    {
        id: "WO6",
        jobType: "COND",
        description: "Condition-based maintenance check",
        createdDate: "2025-02-01",
        equipmentId: "AFE3.0.DIS.LN.01.811015",
        status: "Open",
        priority: 2,
        reqm: "REQM6",
        failure: "Failure6",
        cause: "Cause6"
    },
    {
        id: "WO7",
        jobType: "PM",
        description: "Monthly preventive maintenance",
        createdDate: "2025-02-15",
        equipmentId: "AFE3.0.DIS.LN.01.811015",
        status: "Completed",
        priority: 1,
        reqm: "REQM7",
        failure: "Failure7",
        cause: "Cause7"
    }
]

export const trendChartDataList: Record<string, TrendChartData> = {
    monitron: {
        site: "BCN1",
        asset: "AFE3.0.DIS.LN.01.811015",
        position: "BNLS",
        technology: "monitron",
        timeSeries: [
            {
                key: "vibration",
                label: "RMS",
                data: [
                    { x: "2025-01-01T10:15:30Z", y: 5.2 },
                    { x: "2025-01-05T10:20:30Z", y: 4.8 },
                    { x: "2025-01-10T14:30:00Z", y: 5.5 },
                    { x: "2025-01-15T09:45:15Z", y: 6.1 },
                    { x: "2025-01-20T16:20:45Z", y: 4.9 },
                    { x: "2025-01-25T11:10:20Z", y: 5.8 },
                    { x: "2025-01-30T13:55:10Z", y: 5.3 },
                    { x: "2025-02-05T08:30:00Z", y: 4.7 },
                    { x: "2025-02-10T15:45:30Z", y: 5.6 },
                    { x: "2025-02-15T12:20:15Z", y: 5.1 },
                ]
            },
            {
                key: "temperature",
                label: "Temperature",
                data: [
                    { x: "2025-01-01T10:15:30Z", y: 65.0 },
                    { x: "2025-01-05T10:20:30Z", y: 67.2 },
                    { x: "2025-01-10T14:30:00Z", y: 64.9 },
                    { x: "2025-01-15T09:45:15Z", y: 68.1 },
                    { x: "2025-01-20T16:20:45Z", y: 66.3 },
                    { x: "2025-01-25T11:10:20Z", y: 69.8 },
                    { x: "2025-01-30T13:55:10Z", y: 65.0 },
                    { x: "2025-02-05T08:30:00Z", y: 67.2 },
                    { x: "2025-02-10T15:45:30Z", y: 64.9 },
                    { x: "2025-02-15T12:20:15Z", y: 68.1 },
                ]
            },
            {
                key: "vel_x",
                label: "Velocity_Xaxis",
                data: [
                    { x: "2025-01-01T10:15:30Z", y: 3.1 },
                    { x: "2025-01-05T10:20:30Z", y: 2.8 },
                    { x: "2025-01-10T14:30:00Z", y: 3.4 },
                    { x: "2025-01-15T09:45:15Z", y: 3.8 },
                    { x: "2025-01-20T16:20:45Z", y: 2.9 },
                    { x: "2025-01-25T11:10:20Z", y: 3.6 },
                    { x: "2025-01-30T13:55:10Z", y: 3.2 },
                    { x: "2025-02-05T08:30:00Z", y: 2.7 },
                    { x: "2025-02-10T15:45:30Z", y: 3.5 },
                    { x: "2025-02-15T12:20:15Z", y: 3.1 },
                ]
            },
            {
                key: "vel_y",
                label: "Velocity_Yaxis",
                data: [
                    { x: "2025-01-01T10:15:30Z", y: 2.8 },
                    { x: "2025-01-05T10:20:30Z", y: 2.5 },
                    { x: "2025-01-10T14:30:00Z", y: 3.1 },
                    { x: "2025-01-15T09:45:15Z", y: 3.4 },
                    { x: "2025-01-20T16:20:45Z", y: 2.6 },
                    { x: "2025-01-25T11:10:20Z", y: 3.2 },
                    { x: "2025-01-30T13:55:10Z", y: 2.9 },
                    { x: "2025-02-05T08:30:00Z", y: 2.4 },
                    { x: "2025-02-10T15:45:30Z", y: 3.0 },
                    { x: "2025-02-15T12:20:15Z", y: 2.8 },
                ]
            },
            {
                key: "vel_z",
                label: "Velocity_Zaxis",
                data: [
                    { x: "2025-01-01T10:15:30Z", y: 4.2 },
                    { x: "2025-01-05T10:20:30Z", y: 3.9 },
                    { x: "2025-01-10T14:30:00Z", y: 4.6 },
                    { x: "2025-01-15T09:45:15Z", y: 5.1 },
                    { x: "2025-01-20T16:20:45Z", y: 4.0 },
                    { x: "2025-01-25T11:10:20Z", y: 4.8 },
                    { x: "2025-01-30T13:55:10Z", y: 4.3 },
                    { x: "2025-02-05T08:30:00Z", y: 3.8 },
                    { x: "2025-02-10T15:45:30Z", y: 4.7 },
                    { x: "2025-02-15T12:20:15Z", y: 4.2 },
                ]
            },
        ]
    },
    pulse: {
        site: "BCN1",
        asset: "AFE3.0.DIS.LN.01.811015",
        position: "BNLS",
        technology: "pulse",
        timeSeries: [
            {
                key: "db",
                label: "dB",
                data: [
                    { x: "2025-01-01T10:15:30Z", y: 28 },
                    { x: "2025-01-05T10:20:30Z", y: 30 },
                    { x: "2025-01-10T14:30:00Z", y: 29 },
                    { x: "2025-01-15T09:45:15Z", y: 31 },
                    { x: "2025-01-20T16:20:45Z", y: 27 },
                    { x: "2025-01-25T11:10:20Z", y: 32 },
                    { x: "2025-01-30T13:55:10Z", y: 29 },
                    { x: "2025-02-05T08:30:00Z", y: 28 },
                    { x: "2025-02-10T15:45:30Z", y: 30 },
                    { x: "2025-02-15T12:20:15Z", y: 26 },
                ]
            },
            {
                key: "baseline",
                label: "Baseline",
                data: [
                    { x: "2025-01-01T10:15:30Z", y: 25 },
                    { x: "2025-01-05T10:20:30Z", y: 26 },
                    { x: "2025-01-10T14:30:00Z", y: 24 },
                    { x: "2025-01-15T09:45:15Z", y: 27 },
                    { x: "2025-01-20T16:20:45Z", y: 25 },
                    { x: "2025-01-25T11:10:20Z", y: 26 },
                    { x: "2025-01-30T13:55:10Z", y: 24 },
                    { x: "2025-02-05T08:30:00Z", y: 25 },
                    { x: "2025-02-10T15:45:30Z", y: 26 },
                    { x: "2025-02-15T12:20:15Z", y: 23 },
                ]
            }
        ]
    },
    cadet: {
        site: "BCN1",
        asset: "AFE3.0.DIS.LN.01.811015",
        position: "BNLS",
        technology: "cadet",
        timeSeries: [
            {
                key: "current",
                label: "Current",
                data: [
                { x: "2025-01-01 10:15", y: 0.1250 },
                { x: "2025-01-05 10:20", y: 0.1180 },
                { x: "2025-01-10 14:30", y: 0.1320 },
                { x: "2025-01-15 09:45", y: 0.1290 },
                { x: "2025-01-20 16:20", y: 0.1150 },
                { x: "2025-01-25 11:10", y: 0.1380 },
                { x: "2025-01-30 13:55", y: 0.1220 },
                { x: "2025-02-05 08:30", y: 0.1160 },
                { x: "2025-02-10 15:45", y: 0.1340 },
                { x: "2025-02-15 12:20", y: 0.1270 },
            ]
            },
        ]
    },
    thermal: {
        site: "BCN1",
        asset: "AFE3.0.DIS.LN.01.811015",
        position: "BNLS",
        technology: "thermal",
        timeSeries: [
            {
                key: "temperature",
                label: "Temperature",
                data: [
                    { x: "2025-01-01 10:15", y: 68 },
                    { x: "2025-01-05 10:20", y: 72 },
                    { x: "2025-01-10 14:30", y: 70 },
                    { x: "2025-01-15 09:45", y: 74 },
                    { x: "2025-01-20 16:20", y: 66 },
                    { x: "2025-01-25 11:10", y: 76 },
                    { x: "2025-01-30 13:55", y: 71 },
                    { x: "2025-02-05 08:30", y: 69 },
                    { x: "2025-02-10 15:45", y: 73 },
                    { x: "2025-02-15 12:20", y: 67 },
                ]
            },
            {
                key: "baseline",
                label: "Baseline",
                data: [
                    { x: "2025-01-01 10:15", y: 65 },
                    { x: "2025-01-05 10:20", y: 64 },
                    { x: "2025-01-10 14:30", y: 66 },
                    { x: "2025-01-15 09:45", y: 63 },
                    { x: "2025-01-20 16:20", y: 67 },
                    { x: "2025-01-25 11:10", y: 62 },
                    { x: "2025-01-30 13:55", y: 65 },
                    { x: "2025-02-05 08:30", y: 64 },
                    { x: "2025-02-10 15:45", y: 66 },
                    { x: "2025-02-15 12:20", y: 63 },
                ]
            }
        ]
    }
}
